import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import de from './de.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: en
    },
    de: {
        translation: de
    }
};

const detectionOptions = {
    // order and from where user language should be detected
    order: ['path', 'cookie', 'localStorage', 'navigator'],

    // keys or params to lookup language from
    lookupQuerystring: 'language',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,

    // cache user language on
    caches: ['localStorage', 'cookie'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

    // optional expire and domain for set cookie
    cookieMinutes: 10,
    cookieDomain: 'myDomain',

    // optional htmlTag with lang attribute, the default is:
    htmlTag: document.documentElement
}

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,
        whitelist: ['en', 'de', 'it', 'es', 'ro'],
        fallbackLng: 'en',
        load: 'languageOnly',
        detection: detectionOptions,
        
        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;

export const languages = [
    {
        code: 'en',
        name: 'English',
        iconPath: '/images/icons/flag.jpg',
    },
    {
        code: 'de',
        name: 'Deutsch',
        iconPath: '/images/icons/flag-deutsch.png',
    },
    {
        code: 'it',
        name: 'Italiano',
        iconPath: '/images/icons/flag-italiano.png',
    },
    {
        code: 'es',
        name: 'Espanol',
        iconPath: '/images/icons/flag-espanol.png',
    },
    {
        code: 'ro',
        name: 'Romana',
        iconPath: '/images/icons/flag-romana.png',
    }
]